import React from 'react'
import Slider from 'react-slick'

const PrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="absolute bottom-[-65px] left-[10px] z-10 cursor-pointer"
    >
        <img src="/assets/about/prev.svg" alt="Previous" className="w-[50px] h-[50px]" />
    </div>
);

const NextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="absolute bottom-[-65px] left-[50px] z-10 cursor-pointer"
    >
        <img src="/assets/about/next.svg" alt="Next" className="w-[50px] h-[50px]" />
    </div>
);

function HistorySlider() {
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,

    }

    return (
        <Slider {...settings}>
            <div>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-[72px] px-[20px] md:px-[0] items-center">
                    <div>
                        <p className='font-[500] font-inter text-[18px] text-[#FF6000] pb-[16px]'>HISTORY</p>
                        <h6 className='font-[700] font-manrope lg:text-[50px] text-[30px] text-[#000000] lg:pb-[32px] pb-[20px]'>
                            A Brief History of <br />
                            <span className='text-[#FF6000]'>Narsingh Temple</span>
                        </h6>
                        <p className="lg:pb-[30px] pb-[20px] font-[700] font-manrope text-[31px] leading-[34px] text-[#000000]">2010</p>
                        <p className="font-[500] font-manrope text-[16px] leading-[34px] text-[#000000]">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. <br />
                            Suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat.
                        </p>
                    </div>
                    <div>
                        <img src="/assets/about/img1.png" alt="" className="w-full" />
                    </div>
                </div>
            </div>
            <div>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-[72px] px-[20px] md:px-[0] items-center">
                    <div>
                        <p className='font-[500] font-inter text-[18px] text-[#FF6000] pb-[16px]'>HISTORY</p>
                        <h6 className='font-[700] font-manrope lg:text-[50px] text-[30px] text-[#000000] lg:pb-[32px] pb-[20px]'>
                            A Brief History of <br />
                            <span className='text-[#FF6000]'>Narsingh Temple</span>
                        </h6>
                        <p className="lg:pb-[30px] pb-[20px] font-[700] font-manrope text-[31px] leading-[34px] text-[#000000]">2010</p>
                        <p className="font-[500] font-manrope text-[16px] leading-[34px] text-[#000000]">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. <br />
                            Suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat.
                        </p>
                    </div>
                    <div>
                        <img src="/assets/about/img1.png" alt="" className="w-full" />
                    </div>
                </div>
            </div>
            <div>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-[72px] px-[20px] md:px-[0] items-center">
                    <div>
                        <p className='font-[500] font-inter text-[18px] text-[#FF6000] pb-[16px]'>HISTORY</p>
                        <h6 className='font-[700] font-manrope lg:text-[50px] text-[30px] text-[#000000] lg:pb-[32px] pb-[20px]'>
                            A Brief History of <br />
                            <span className='text-[#FF6000]'>Narsingh Temple</span>
                        </h6>
                        <p className="lg:pb-[30px] pb-[20px] font-[700] font-manrope text-[31px] leading-[34px] text-[#000000]">2010</p>
                        <p className="font-[500] font-manrope text-[16px] leading-[34px] text-[#000000]">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. <br />
                            Suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat.
                        </p>
                    </div>
                    <div>
                        <img src="/assets/about/img1.png" alt="" className="w-full" />
                    </div>
                </div>
            </div>
        </Slider>
    )
}

export default HistorySlider
